// The "What's New" feed, parsed from the static /changelog.json the build
// generates. Not an API resource, so there is no generated Zod to derive from.
import { z } from 'zod';

const changelogEntrySchema = z.object({
  id: z.string(),
  date: z.string(), // ISO date
  title: z.string(),
  summary: z.string(),
  tags: z.array(z.string()).default([]),
  // Optional click-through target (e.g. a help-center article). When absent
  // the "What's New" bell renders the entry as plain text — no dead link.
  url: z.string().optional(),
  image: z.string().nullable().optional(),
  // How the update is announced: the What's New card, or the demo dialog for big releases.
  announce: z.enum(['card', 'dialog']).default('card'),
  // A demo video and a short how-to, shown in the dialog and from the bell.
  showcase: z
    .object({
      video: z.string(),
      poster: z.string().optional(),
      highlights: z.array(z.string()).default([]),
      steps: z.array(z.string()).default([]),
    })
    .optional(),
});
export type ChangelogEntry = z.infer<typeof changelogEntrySchema>;

export const changelogSchema = z.object({
  entries: z.array(changelogEntrySchema),
});
